import { Inject, Injectable } from '@angular/core'
import { Configurations } from '../configurations/models/configurations.model'
import { APP_CONFIG } from '../configurations/configurations.factory'
import { EnvironmentConfigurations } from '../configurations/models/environment-configurations.model'
import { AuthProxyService } from 'src/app/infrastructure/porto/porto-proxy-auth/auth-proxy.service'
import { BehaviorSubject, Observable, Subject, catchError, filter, iif, map, of, switchMap, tap } from 'rxjs'
import { AuthenticationService } from './authentication.service'

@Injectable({
  providedIn: 'root'
})
export class PortoAuthenticationService {

  private token$ = new BehaviorSubject<string>('')
  private isFetching = false
  private deadline: Date | undefined

  private readonly envConfig: EnvironmentConfigurations
  private userName: string

  constructor(@Inject(APP_CONFIG) config: Configurations,
    private readonly authProxyService: AuthProxyService,
    private readonly authenticationService: AuthenticationService) {
    this.envConfig = config.environmentConfig
    this.userName = config.authenticationConfig.portoUserName
  }

  login$() {
    return this.authenticationService.getAccessToken().pipe(
      switchMap(token => this.authProxyService.login$(this.userName, token)),
      tap(response => {
        const now = new Date()
        this.deadline = new Date(now.setSeconds(now.getSeconds() + response.expires_in))
      }),
      map(response => response.access_token)
    )
  }

  getAccessToken$(): Observable<string> {

    const currentToken = this.token$.getValue()

    if (currentToken && this.deadline && this.deadline?.getTime() > new Date().getTime())
      return this.token$.pipe(filter(token => !!token))


    if (!this.isFetching) {
      this.isFetching = true

      this.login$().pipe(
        tap((token) => {
          this.token$.next(token)
          this.isFetching = false
        }),
        catchError((error) => {
          this.isFetching = false
          throw error
        })
      ).subscribe()
    }

    return this.token$.pipe(filter(token => !!token))

  }
}


